import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getSelectionListsByPlant } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch selection lists for the selected plant.
 * @param {string} [plant] - Optional plant filter, defaults to selected plant in context
 */
export const useSelectionLists = (plant) => {
  const { apiReady } = useApiReady();
  const { selectedPlant } = useAppContext();

  const effectivePlant = plant || selectedPlant;

  return useQuery({
    queryKey: [QUERY_KEYS.SELECTION_LISTS, effectivePlant],
    queryFn: () => getSelectionListsByPlant(effectivePlant),
    enabled: Boolean(apiReady && effectivePlant),
  });
};
